import React, { useState } from 'react';
import logo from '../../assets/images/Logo.png';
import loginStyles from '../../styles/loginStyles';
import { useNavigate } from 'react-router-dom';
import api from '../../api/axiosConfig';
import { endpoints } from '../../api/endpoints';

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    setError('');
    setMessage('');
    setLoading(true);

    try {
      const response = await api.post(endpoints.auth.forgotPassword, {
        email,
      });

      const successMessage =
        response.data?.message ||
        response.data?.detail?.message ||
        `Password reset link sent to ${email}`;

      setMessage(successMessage);
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (err: any) {
      const errorMessage =
        err.response?.data?.detail?.message ||
        err.response?.data?.message ||
        err.response?.data?.detail ||
        err.message ||
        'Failed to send reset link. Please try again.';

      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={loginStyles.pageBG}>
      <div style={loginStyles.container}>
        <div style={loginStyles.logoBox}>
          <img src={logo} alt="Logo" style={loginStyles.logo} />
          <h2 style={loginStyles.heading}>Reset your password</h2>
          <p style={loginStyles.instruction}>Enter your email address and we'll send you instructions to reset your password.</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={loginStyles.field}>
            <label htmlFor="email" style={loginStyles.label}>Email Address</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              disabled={loading}
              placeholder="Enter your email"
              style={loginStyles.input}
            />
          </div>
          <button type="submit" disabled={loading} style={{ ...loginStyles.button, opacity: loading ? 0.7 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}>
            {loading ? 'SENDING...' : 'SEND RESET LINK'}
          </button>
          {error && (
            <div style={loginStyles.error}>
              <span style={{ fontWeight: 'bold', fontSize: 18 }}>⚠</span>
              <span>{error}</span>
            </div>
          )}
          {message && (
            <div style={loginStyles.success}>
              <span style={{ fontWeight: 'bold', fontSize: 18 }}>✓</span>
              <span>{message}</span>
            </div>
          )}
        </form>
        <div style={loginStyles.backLink}>
          <button
            onClick={() => navigate('/login')}
            disabled={loading}
            style={loginStyles.backButton}
          >
            Back to Sign In
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
